import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  .Toastify__toast--warning {
    background-color: #F0B01B;
  }

  .Toastify__toast--success {
    background: ${({ theme }) => theme.colors.lightGreen};
    color: ${({ theme }) => theme.colors.purple};
    font-family: 'Mangueira', sans-serif !important;
  }

  body {
    background-color: #F5F5F5;
    -webkit-font-smoothing: antialiased;
    font-family: 'Mangueira', sans-serif !important;
    overflow: auto;
  }

  button {
    cursor: pointer;
  }

  input::-webkit-inner-spin-button {
    display: none;
  }

  #indecx-widget-content {
    max-width: 672px !important;
    padding: 20px !important;
  }

  .css-3ddbcp {
    z-index: 9999999999 !important;
  }

  #ultra-widget-container {
    top: 70% !important;
    transform: translateY(-50%) !important;
  }

  #ultra-widget-panel {
    bottom: 50px !important;
  }
`;
